import { render, staticRenderFns } from "./CommonInfo2.vue?vue&type=template&id=7b5d1580&scoped=true&"
import script from "./CommonInfo2.vue?vue&type=script&lang=js&"
export * from "./CommonInfo2.vue?vue&type=script&lang=js&"
import style0 from "./CommonInfo2.vue?vue&type=style&index=0&id=7b5d1580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5d1580",
  null
  
)

export default component.exports